import { thousandSeperator } from "@utils/general/digit-separators";
import DataTable from "react-data-table-component";

const DeliveryItemTable = (props: { data: any[] }) => {
  return (
    <DataTable
      //   conditionalRowStyles={[
      //     {
      //       when: (row) => row.product_code === "Totals:",
      //       style: {
      //         backgroundColor: "#f3f4f6",
      //         fontWeight: 500,
      //       },
      //     },
      //   ]}
      columns={[
        {
          name: "Product ID",
          selector: (row: any) => row.product_code,
        },
        {
          name: "Product Name",
          selector: (row: any) => row.product_name,
        },
        {
          name: "Allocation Account",
          selector: (row: any) => row.warehouse_name,
        },
        {
          name: "Request Qty",
          selector: (row: any) =>
            row.noAction ? null : thousandSeperator(row.request_qty || 0),
        },
        {
          name: "Unit",
          selector: (row: any) =>
            row.noAction ? null : thousandSeperator(row.unit_name || 0),
        },
        {
          name: "Balance",
          selector: (row: any) =>
            row.noAction
              ? null
              : thousandSeperator(row.issued_balance_qty || 0),
        },
        {
          name: "Issue Qty",
          selector: (row: any) =>
            row.noAction ? null : thousandSeperator(row.total_issued_qty || 0),
        },
      ]}
      data={props.data}
      striped
      responsive
    />
  );
};

export default DeliveryItemTable;
